export default {
    ACTION: {
        CREATE: 'create',
        EDIT: 'edit',
        DELETE: 'delete'
    },
    MODEL: {
        ACTION: 'action',
        ACTUALITY: 'actuality',
        ALERT: 'alert',
        CATEGORY: 'category',
        DOCUMENT: 'document',
        EMPLOYEE: 'employee',
        EVENT: 'event',
        NOTICE: 'notice',
        SUB_CATEGORY: 'sub_category'
    }
}